import { TemplateConfig } from '../types';

export const careerDevelopmentConfig: TemplateConfig = {
  id: 'career-development',
  name: '事业发展前景',
  description: '分析现在的工作对人生的影响以及事业发展方向',
  cardCount: 5,
  
  fieldDefaults: {
    title: '事业发展前景',
    customerQuestion: '现在的工作对我的人生来说是助力还是拖累？面对现在的这份工作我需要做什么？',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 4 列第 1 张牌',
      '请输入第 5 列第 1 张牌'
    ],
    cardInfos: [
      '选择这份工作的原因',
      '这条路是对的吗',
      '主要障碍',
      '什么对我有益',
      '如何让我的事业持续发展'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '💼'
  }
};